import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial?",
  answer: 'Every new account gets free credits to test the API before committing to a paid plan. You can search local businesses, enrich company data, and find decision makers — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'How does Openmart compare to other places APIs?',
  answer: 'Openmart is designed as a comprehensive local business API. While most places APIs restrict data storage and charge extra for specific data fields, Openmart allows you to cache data, use it for lead generation, and provides all data fields (including emails) for a flat, predictable price.'
}, {
  question: 'Is Openmart a reliable places API alternative?',
  answer: 'Yes. Thousands of developers use Openmart as their primary places API because it offers richer data fields, no restrictive terms of service regarding data storage, and significantly lower costs at scale.'
}, {
  question: 'What data fields does the local business API return?',
  answer: 'Our local business data API returns over 50 data points per local business. This includes standard NAP (Name, Address, Phone) data, plus direct emails, social media links, operating hours, review aggregates, and estimated financial metrics.'
}, {
  question: 'What are the rate limits for the places API?',
  answer: 'Our standard plans allow up to 600 requests per minute, which is significantly higher than many competitors. Enterprise plans offer custom rate limits up to 100 requests per second to support high-volume data enrichment.'
}, {
  question: 'How much does the local business API cost?',
  answer: 'Most places APIs charge per request and add surcharges for specific data fields (like contact info or atmosphere data). Openmart uses a flat monthly subscription model with generous quotas, often resulting in 50-80% cost savings for high-volume users.'
}, {
  question: 'Can I use this API for lead generation?',
  answer: 'Absolutely. Unlike most places APIs which prohibit using their data for direct marketing or lead generation, Openmart fully supports and encourages using our local business data API to build B2B sales lists and enrich CRM records in Salesforce, HubSpot, and more.'
}, {
  question: 'How fresh is the local business data?',
  answer: 'We continuously crawl, verify, and update our database of millions of local businesses. Records are updated on a weekly basis, ensuring you receive highly accurate, up-to-date local business intelligence.'
}, {
  question: 'Does Openmart work as a local business API?',
  answer: 'Yes. Openmart is purpose-built as a local business API. Whether you need data on independent shops, franchises, or enterprise chains, our local business API covers 200M+ local businesses globally with verified contact details, revenue estimates, and more.'
}, {
  question: 'What makes Openmart different as a local business search API?',
  answer: 'Our local business search API goes beyond basic name and address lookups. You can search by category, location, revenue range, employee count, and tech stack. Combined with our local business data API, it gives you the most comprehensive local business search API available today.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-1174">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1175">
        <div className="text-center mb-10" data-id="element-1176">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-1177">
            Frequently asked <span className="text-blue-600" data-id="element-1178">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-1179">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-1180">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-1181">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-1182">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-1183" />
                </button>

                <AnimatePresence data-id="element-1184">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-1185">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-1186" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}